"use client";

import { useTranslation } from "react-i18next";
import Modal from "@/components/library/Modal";

interface DisconnectModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  integrationName: string;
  isLoading?: boolean;
}

export default function DisconnectModal({
  show,
  onClose,
  onConfirm,
  integrationName,
  isLoading = false,
}: DisconnectModalProps) {
  const { t } = useTranslation("partners");
  const { t: ct } = useTranslation("common");

  const formattedName = integrationName
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <Modal
      open={show}
      onOpenChange={(open) => !open && onClose()}
      header={{
        title: `${ct("disconnect")}? (${formattedName})`,
        className: "font-monument",
      }}
      buttons={[
        {
          type: "primary",
          onClick: onConfirm,
          children: ct("disconnect"),
          destructive: true,
          disabled: isLoading,
        },
        {
          type: "secondary",
          onClick: onClose,
          children: ct("cancel"),
          disabled: isLoading,
        },
      ]}
    >
      <p>{t("tools.connectedAppDisconnectMessage")}</p>
    </Modal>
  );
}
